import React, { useEffect } from 'react'
import { Get } from '../../config/api/get';
import { RIDE } from '../../config/constants/api';
import { useQuery } from "react-query";
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

export default function CheckRoute({children}) {
    const token = useSelector((state) => state.user.userToken);
    const navigate = useNavigate()
    const getUserOngoingRide = async () => {
        const response = await Get(RIDE.getUserOngoingRide, token);
        if (response?.status) {
          return response?.data;
        } else {
          console.log("Error fetching ride");
        }
      };
      const { data, error, isLoading } = useQuery(
        "userOngoingRide", // Unique query key based on the user ID
        getUserOngoingRide
      );
      useEffect(()=>{
        if(data){
            navigate(`/ride/${data?._id}`)
        }
      },[])  

return <>{children}</>;
}
